import { Fragment } from "react";

import SkipLink from "../_kit/SkipLink";
import Rooms from "../home/Rooms";
import Header from "../home/Header";
import Gallery from "../home/Gallery";
import Footer from "../home/Footer";
import Facilities from "../home/Facilities";
import About from "../home/About";
import {
  useLandingLanguage,
  LandingLanguageProvider,
} from "../../../contexts/landing-language";

/* "/hebe/about" — the property.
 *
 * These four sections used to sit under the hero on /hebe. The chrome and the sections still live
 * under pages/hebe/home because every other page already imports Header and Footer from there;
 * moving them would churn five call sites for no behavioural gain.
 */
const AboutContent = () => {
  const { t } = useLandingLanguage();

  return (
    <Fragment>
      <SkipLink href="#main">{t.hero.scrollHint}</SkipLink>
      <Header forceScrolled />
      <main id="main">
        <About />
        <Facilities />
        <Rooms />
        <Gallery />
      </main>
      <Footer />
    </Fragment>
  );
};

const AboutPage = () => (
  <LandingLanguageProvider>
    <AboutContent />
  </LandingLanguageProvider>
);

export default AboutPage;
